<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">Table of Contents</h2>
<p class="toc"> </p>
<p class="toc"><span href="#/xhtml/title" title="Link target outside of Sample">Title</span></p>
<p class="toc"><a href="#/xhtml/copyright">Copyright</a></p>
<p class="toc"><a href="#/xhtml/part01">Part 1</a></p>
<p class="toc"><span href="#/xhtml/part02" title="Link target outside of Sample">Part 2</span></p>
<p class="toc"><span href="#/xhtml/part03" title="Link target outside of Sample">Part 3</span></p>
<p class="toc"><span href="#/xhtml/part04" title="Link target outside of Sample">Part 4</span></p>
<p class="toc"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?9b2b25ca